var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
/** @jsxImportSource theme-ui */
import { Formik, useFormikContext } from "formik";
import { useFormTheme } from ".";
import { FormThemeProvider } from "./useFormTheme";
/**
 * Renders a form via Formik that is validated using a yup schema.
 *
 * @template {import('formik').FormikValues} Values
 * @param {import('formik').FormikConfig<Values>
 *    & Required<Pick<import('formik').FormikConfig<Values>, 'validationSchema'>>
 *    & {
 *      theme?: import('./useFormTheme').FormThemeVariant | import('./useFormTheme').FormTheme;
 *    }
 *    & HtmlFormProps
 * } props
 * @returns
 */
export default function Form(_a) {
    var { initialValues, validationSchema, onSubmit, children, theme = "classic" } = _a, props = __rest(_a, ["initialValues", "validationSchema", "onSubmit", "children", "theme"]);
    // Extract all Formik props and leave only the rest for the HTML form element.
    const { component, enableReinitialize, initialErrors, initialStatus, initialTouched, innerRef, isInitialValid, onReset, render, validate, validateOnBlur, validateOnChange, validateOnMount } = props, formProps = __rest(props, ["component", "enableReinitialize", "initialErrors", "initialStatus", "initialTouched", "innerRef", "isInitialValid", "onReset", "render", "validate", "validateOnBlur", "validateOnChange", "validateOnMount"]);
    return (_jsx(Formik, { initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit, render: render, onReset: onReset, component: component, enableReinitialize: enableReinitialize, initialErrors: initialErrors, initialStatus: initialStatus, initialTouched: initialTouched, innerRef: innerRef, isInitialValid: isInitialValid, validate: validate, validateOnBlur: validateOnBlur, validateOnChange: validateOnChange, validateOnMount: validateOnMount, children: _jsx(FormThemeProvider, { value: theme, children: _jsx(HtmlForm, Object.assign({}, formProps, { children: children })) }) }));
}
/**
 * @typedef {Omit<import('react').FormHTMLAttributes, 'onSubmit' | 'onReset'>} HtmlFormProps
 */
/**
 * This reimplements the formik.Form component because I couldn't extract the typings for formik's implementation correctly.
 */
function HtmlForm(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { handleReset, handleSubmit } = useFormikContext();
    const theme = useFormTheme();
    return (_jsx("form", Object.assign({ sx: theme === null || theme === void 0 ? void 0 : theme.form }, rest, { onReset: handleReset, onSubmit: handleSubmit, children: children })));
}
//# sourceMappingURL=Form.js.map